import React, { useState } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../shared/BrandModal.css";

export const ReopenModal = ({ toggle, setToggle, onSubmit, requestId }) => {
  const [reason, setReason] = useState("");
  const [showAdditionalError, setShowAdditionalError] = useState(false);

  const triggerToggle = () => {
    setToggle(!toggle);
  };

  const submitted = async (e) => {
    e.preventDefault();

    let validated = validate();

    if (!validated) {
      return;
    }

    triggerToggle();
    onSubmit(requestId, reason);
  };

  const validate = () => {
    let isSuccess = true;

    if (!reason) {
      setShowAdditionalError(true);
      isSuccess = false;
    }

    return isSuccess;
  };

  const reset = () => {
    setReason("");
    setShowAdditionalError(false);
  };

  return (
    <Modal isOpen={toggle} toggle={triggerToggle} size="lg" className="brand-modal">
      <ModalHeader toggle={triggerToggle}>Reopen Request</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          Please provide a reason for reopening this request.
        </p>
        <Form onSubmit={submitted}>
          <FormGroup>
            <Label for="additionalEmail">Reason</Label>
            <Input
              type="textarea"
              name="reason"
              id="reason"
              placeholder="Reason text that will be included in email"
              onChange={(e) => setReason(e.target?.value)}
              value={reason}
            />
            {showAdditionalError && <p className="text-danger">Required</p>}
          </FormGroup>

          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--primary">
              <FontAwesomeIcon icon={faRedo} /> Reopen
            </button>
            <button
              type="button"
              className="brand-modal__btn brand-modal__btn--cancel"
              onClick={() => {
                triggerToggle();
                reset();
              }}
            >
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
